import type { BusinessRoundInterestedParticipant } from './networkingApi';
import type { ManualContactRow } from './PartnerManualFields';

function norm(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

/** Coincide participante del listado con una fila de contraparte ya cargada. */
export function participantMatchesManualContact(
  participant: BusinessRoundInterestedParticipant,
  contact: ManualContactRow
): boolean {
  const contactEmail = norm(contact.email);
  const participantEmail = norm(participant.hideContact ? '' : participant.email);
  if (contactEmail && participantEmail && contactEmail === participantEmail) {
    return true;
  }
  const name = norm(participant.fullName);
  const contactName = norm(contact.fullName);
  const org = norm(participant.organization);
  const contactOrg = norm(contact.organization);
  return !!(name && contactName && name === contactName && org === contactOrg);
}

export function isParticipantAlreadyInManualContacts(
  participant: BusinessRoundInterestedParticipant,
  contacts: ManualContactRow[]
): boolean {
  return contacts.some((c) => participantMatchesManualContact(participant, c));
}
